import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KGrid";
var classes = {
    dataview: "".concat(PREFIX, "-dataview")
};
var StyledKGrid = styled(Box)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.dataview)] = (_c = {
                margin: 0,
                padding: 0,
                display: "grid",
                gap: "20px",
                alignItems: "stretch",
                gridTemplateColumns: "repeat(auto-fill, minmax(15rem, 1fr))",
                listStyle: "none",
                paddingLeft: 0
            },
            _c[theme.breakpoints.down("md")] = {
                gap: theme.spacing(1),
                gridTemplateColumns: "repeat(auto-fill, minmax(10rem, 1fr))"
            },
            _c[theme.breakpoints.down("sm")] = {
                gridTemplateColumns: "repeat(auto-fit, minmax(min(130px, 50%), 1fr))"
            },
            _c),
        _b);
});

export { classes, StyledKGrid as default };
//# sourceMappingURL=index.styled.js.map
